/* ------------------------------------------------------------------ */
/*  LIGHT THEME — Live Requests / API Registry (mirrors AuditLog.jsx)  */
/* ------------------------------------------------------------------ */
export const THEME = {
    primary: "#4A66F1",
    primary08: "rgba(74, 102, 241, 0.08)",
    primary16: "rgba(74, 102, 241, 0.16)",
    primaryBorder: "rgba(74, 102, 241, 0.24)",
    bgDefault: "#f5f5f5",
    bgPaper: "#ffffff",
    bgLight: "#FAFAFA",
    bgTableHeader: "#F5F5F5",
    textPrimary: "#212121",
    textSecondary: "#616161",
    textDark: "#1a1a1a",
    textMedium: "#424242",
    divider: "#EBEBEB",
    border: "#E0E0E0",
    warning: "#FF9800",
    warningBg: "#FFF4E5",
    warningText: "#5F370E",
    error: "#F44336",
    errorBg: "rgba(244, 67, 54, 0.08)",
    success: "#2E7D32",
    successBg: "#E8F5E9",
    info: "#0288D1",
    infoBg: "#E1F5FE",
    radius: { base: 8, card: 12, cardLg: 16, dialog: 20, pill: 999 },
    shadow: {
        sm: "0px 1px 3px rgba(0, 0, 0, 0.08)",
        md: "0px 2px 8px rgba(0, 0, 0, 0.08)",
    },
    font: '"Roboto", "Helvetica", "Arial", sans-serif',
    mono: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, monospace',
};

/* ------------------------------------------------------------------ */
/*  DARK THEME — Dashboard tab                                         */
/*  Values from the dataviz skill's reference palette (dark surface):  */
/*  chart surface / page plane / ink / status roles all pulled from    */
/*  references/palette.md, not hand-picked.                            */
/* ------------------------------------------------------------------ */
export const DARK_THEME = {
    // chrome
    surface: "#1a1a19",       // chart / card surface
    page: "#0d0d0d",          // page plane behind cards
    textPrimary: "#ffffff",
    textSecondary: "#c3c2b7",
    textMuted: "#898781",
    gridline: "#2c2c2a",
    baseline: "#383835",
    border: "rgba(255, 255, 255, 0.10)",

    // sequential accent (single hue — meters, lines, bars). Step 400 of the
    // reference sequential blue ramp, validated for the dark surface band.
    accent: "#3987e5",
    accentTrack: "#2c2c2a",   // unfilled meter track — recedes into the surface

    // status palette (fixed, never themed — same steps light & dark)
    status: {
        good: "#0ca30c",
        warning: "#fab219",
        serious: "#ec835a",
        critical: "#d03b3b",
    },

    radius: { base: 8, card: 14, cardLg: 18 },
    font: '"Roboto", "Helvetica", "Arial", sans-serif',
    mono: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, monospace',
};

/* HTTP status -> status-palette role */
export const statusRole = (httpStatus) => {
    if (httpStatus >= 500) return "critical";
    if (httpStatus >= 400) return "warning";
    if (httpStatus >= 300) return "neutral";
    return "good";
};

/* CPU / heap ratio -> severity step (meter fill follows accent -> warning -> danger) */
export const meterSeverity = (ratio) => {
    if (ratio >= 0.9) return "critical";
    if (ratio >= 0.7) return "warning";
    return "accent";
};
